<div class="sidenav-container" [ngClass]="{ 'menu-open': isMenuOpen && isHandset }">
  <div
    class="sidenav"
    [ngClass]="{
      'menu-close': !isMenuOpen,
      'menu-open': isMenuOpen,
      'is-handset': isHandset,
      'is-desktop': !isHandset,
    }"
    [ngStyle]="{
      'z-index': 9999,
      transform: isHandset ? (isMenuOpen ? 'translateX(0)' : 'translateX(-100%)') : 'translateX(0)',
    }"
  >
    <ng-content select="[sidenav]"></ng-content>
  </div>

  <div class="overlay" (click)="toggle()"></div>

  <div class="sidenav-content">
    <ng-content select="[sidenav-content]"></ng-content>
  </div>
</div>
